<template>
  <div id="project-status-bar-w">
    <div class="status-viewer">
      <div class="container-in-progress" v-if="currentStage !== 'DONE'">
        <div :class="barStyle.measurement">{{currentStage === 'MEASUREMENT' ? 'Measurement' : ''}}</div>
        <div :class="barStyle.manufacture">{{currentStage === 'MANUFACTURE' ? 'Manufacture' : ''}}</div>
        <div :class="barStyle.installation">{{currentStage === 'INSTALLATION' ? 'Installation' : ''}}</div>
      </div>
      <div class="container-done" v-else>
        Ptoject Finished
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProjectStatusBar',
  props: {
    currentStage: String
  },
  computed: {
    barStyle: function () {
      switch (this.currentStage) {
        case 'MEASUREMENT':
          return {
            measurement: 'bar measurement current',
            manufacture: 'bar manufacture after',
            installation: 'bar installation after'
          }
        case 'MANUFACTURE':
          return {
            measurement: 'bar measurement done',
            manufacture: 'bar manufacture current',
            installation: 'bar installation after'
          }
        case 'INSTALLATION':
          return {
            measurement: 'bar measurement done',
            manufacture: 'bar manufacture done',
            installation: 'bar installation current'
          }
        default:
          return {
            measurement: 'bar measurement current',
            manufacture: 'bar manufacture after',
            installation: 'bar installation after'
          }
      }
    }
  }
}
</script>

<style>
#project-status-bar-w {
  width: 100%;
  margin-top: 12px;
}

.container-in-progress {
  width: 100%;
  height: 20px;
  display: flex;
}

.container-done {
  width: 100%;
  height: 20px;
  border-radius: 5px;
  text-align: center;
  background-color: #27ae60;
  color: white;
  text-align: center;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.bar {
  width: 25%;
  height: 100%;
  margin: 0;
  color: white;
  text-align: center;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.measurement {
  border-radius: 5px 0 0 5px;
}

.installation {
  border-radius: 0 5px 5px 0;
}

.measurement.done {
  background-color: #3498db;
}

.manufacture.done {
  background-color: #e67e22;
}

.installation.done {
  background-color: #34495e;
}

.measurement.current{
  background-color: #3498db;
  width: 50%;
}

.manufacture.current {
  background-color: #e67e22;
  width: 50%;
}

.installation.current {
  background-color: #34495e;
  width: 50%;
}

.measurement.after {
  box-shadow: inset 0 0 0 3px #3498db;
  -moz-box-shadow: inset 0 0 0 3px #3498db;
  -webkit-box-shadow: inset 0 0 0 3px #3498db;
  background-color: rgba(52, 152, 219, 0.3);
}

.manufacture.after {
  box-shadow: inset 0 0 0 3px #e67e22;
  -moz-box-shadow: inset 0 0 0 3px #e67e22;
  -webkit-box-shadow: inset 0 0 0 3px #e67e22;
  background-color: rgba(230, 126, 34, 0.3);
}

.installation.after {
  box-shadow: inset 0 0 0 3px #34495e;
  -moz-box-shadow: inset 0 0 0 3px #34495e;
  -webkit-box-shadow: inset 0 0 0 3px #34495e;
  background-color: rgba(52, 73, 94, 0.3);
}

</style>
